export default {
  common: {
    login: "Anmelden",
    userName: "Benutzername",
    password: "Passwort",
    rememberPassword: "Erinnern",
    modifyPassword: "Passwort ändern",
    accountRegister: "Konto registrieren",
    pleaseInput: "Bitte eingeben",
    loginErrorCheckNamePassword: "Anmeldung fehlgeschlagen, bitte Benutzername und Passwort überprüfen",
    guest: "Gast",
    superAdmin: "Super-Admin",
    logOut: "Abmelden",
    inputUserName: "Benutzername eingeben",
    inputPassword: "Passwort eingeben",
    modifySuccessfully: "Passwort erfolgreich ändern!",

    using: "verwenden",
    toLogin: "zum Login",

    noOktaLoginUrl: "Keine OKTA-Login-URL"
  },
  register: {
    email: "E-Mail",
    confirmPassword: "Passwort bestätigen",
    register: "Registrieren",
    emailRequire: "E-Mail ist erforderlich",
    passwordRequire: "Passwort ist erforderlich",
    confirmPasswordRequire: "Passwortbestätigung ist erforderlich",
    passwordInconsistency: "Passwortinkonsistenz",
    registeredSuccessfully: "Erfolgreich registriert!",
    jumpToLoginPage: "Das System wird Sie automatisch zur Anmeldeseite weiterleiten.",
    contactAdminActivate: "Bitte kontaktieren Sie den Administrator, um das Konto zu aktivieren, bevor Sie sich anmelden."
  },
  my: {
    about: "Über",
    language: "Sprache"
  }
}



// WEBPACK FOOTER //
// ./src/locale/login/de.js